export default __webpack_public_path__ + "static/media/browse_content_pers.348afb6f.svg";